import { CPT } from "./CompteurNonLus";
import { addReaderBadge, removeReaderBadge } from "./MessagerieMessage";

export function mettreAJourMessageDOM(data: any) {
    if (!data) return;
    const selectors: string[] = [];
    if (data.msg_pk) {
        selectors.push(`#msgid_${data.msg_pk}`);
    }
    if (data.corps_pk) {
        selectors.push(`[data-corps="${data.corps_pk}"]`);
    }
    if (selectors.length === 0) return;

    const elements = document.querySelectorAll<HTMLElement>(selectors.join(', '));
    elements.forEach((msgHeader) => {
        if (data.action === 'message_lu') {
            addReaderBadge(msgHeader, data.user_pk, data.couleur, data.nom, data.date);
            msgHeader.style.fontWeight = 'normal';
        } else if (data.action === 'message_nonlu') {
            removeReaderBadge(msgHeader, data.user_pk, data.nom);
            const remainingBadges = msgHeader.querySelectorAll('.badge-lecteur');
            const nbRestants = typeof data.nb_lus_restants === 'number' ? data.nb_lus_restants : remainingBadges.length;
            if (nbRestants === 0) {
                msgHeader.style.fontWeight = 'bold';
            } else {
                msgHeader.style.fontWeight = 'normal';
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    // Connexion WebSocket pour tous les utilisateurs connectés
    if (!window.Openscop || !window.Openscop.is_log) {
        return;
    }

    const wsScheme = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const wsUrl = `${wsScheme}//${window.location.host}/ws/messagerie/`;
    let socket: WebSocket | null = null;
    let heartbeatInterval: number | null = null;
    let reconnectTimeout: number | null = null;

    const connect = () => {
        try {
            socket = new WebSocket(wsUrl);

            socket.onopen = () => {
                console.log('%c[WebSocket Messagerie] Connecté avec succès au serveur Django Channels !', 'color: #00aa00; font-weight: bold;');

                // Heartbeat toutes les 25s pour maintenir ouverts proxies et connexions
                if (heartbeatInterval) clearInterval(heartbeatInterval);
                heartbeatInterval = window.setInterval(() => {
                    if (socket && socket.readyState === WebSocket.OPEN) {
                        socket.send(JSON.stringify({ action: 'heartbeat' }));
                    }
                }, 25000);
            };

            socket.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    console.log('[WebSocket Messagerie] Événement reçu :', data);

                    // 1. Mettre à jour immédiatement les éléments correspondants dans le DOM s'ils sont affichés
                    if (data.action === 'message_lu' || data.action === 'message_nonlu') {
                        mettreAJourMessageDOM(data);
                    }

                    // 2. Déclencher un événement personnalisé pour la messagerie et les vues spécifiques
                    window.dispatchEvent(new CustomEvent('openscop:messagerie_update', { detail: data }));

                    // 3. Mettre à jour immédiatement les compteurs et badges de navigation
                    if (data.action === 'message_lu' || data.action === 'message_nonlu' || data.action === 'refresh_messagerie' || data.action === 'all_messages_lu' || data.action === 'nouveau_message') {
                        CPT();
                    }
                } catch {
                    console.log('[WebSocket Messagerie] Message brut reçu :', event.data);
                }
            };

            socket.onerror = (error) => {
                console.warn('[WebSocket Messagerie] Erreur de connexion ou instance Channels inaccessible :', error);
            };

            socket.onclose = (event) => {
                if (heartbeatInterval) {
                    clearInterval(heartbeatInterval);
                    heartbeatInterval = null;
                }

                if (event.code === 4001) {
                    console.log('%c[WebSocket Messagerie] Session expirée ou utilisateur déconnecté (code 4001). Arrêt du WebSocket.', 'color: #d9534f; font-weight: bold;');
                    return;
                }

                // Reconnexion automatique après 3s si pas de fermeture normale (1000) ni de refus d'authentification (4001)
                if (event.code !== 1000 && event.code !== 4001) {
                    if (reconnectTimeout) clearTimeout(reconnectTimeout);
                    reconnectTimeout = window.setTimeout(connect, 3000);
                }
            };
        } catch (e) {
            console.error('[WebSocket Messagerie] Erreur lors de l\'initialisation du WebSocket :', e);
        }
    };

    connect();

    window.addEventListener('beforeunload', () => {
        if (heartbeatInterval) clearInterval(heartbeatInterval);
        if (reconnectTimeout) clearTimeout(reconnectTimeout);
        if (socket) socket.close(1000, "Navigation");
    });
});
